/**
 * 描述：策划中心左侧导航指令
 * 作者：Bai.Zhiming
 * 日期：2017-8-18
 */
"use strict";
angular.module("planningCenterLeftModule", ["realTimeCluesLeftModule", "commandLeftModule", "eventAnalysisLeftModule"]).
controller("planningCenterLeft", ["$scope", "$q", "$element", "$state", "trsHttpService", "$timeout", "$location", function($scope, $q, $element, $state, trsHttpService, $timeout, $location) {
    initStatus();
    initData();
    /**
     * [initStatus description]初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            accessAuthority: {},
            eventRights: {},
            selectedItem: ""
        };
    }
    /**
     * [autoLocation description] 自动定位路由
     * @return {[type]} [description]
     */
    function autoLocation() {
        let timer = $timeout(() => {
            if ($state.current.name == "front.plan") {
                let leve1 = $element.find(".leve1").eq(0);
                leve1.find("a")[0].click();
                let leve2 = leve1.find(".leve2 li a");
                if (leve2.length > 0) leve2[0].click();
            } else {
                $scope.status.selectedItem = $state.current.name.split(".")[2];
            }
        }, 1000);

        $scope.$on("$destroy", () => {
            $timeout.cancel(timer);
        });
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        $q.all([getCommandAccessAuthority(), getEventanalysisRights()]).then(() => {
            autoLocation();
        });
    }
    /**
     * [getEventanalysisRights description] 选题事件显示隐藏权限
     * @return {[type]} [description] null
     */
    function getEventanalysisRights() {
        var params = {
            'Classify': 'sjfx',
            'ModalName': '事件分析',
            'methodname': 'queryOperKeysOfNormalModal',
            'serviceid': 'mlf_metadataright'
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
            .then(function(data) {
                angular.forEach(data, function(value, key) {
                    $scope.status.eventRights[value.OPERNAME] = true;
                });
            });
    };
    /**
     * [getAccessAuthority description] 获取访问权限
     * @return {[type]} [description]
     */
    function getCommandAccessAuthority() {
        var params = {
            methodname: "queryOperTypesByModal",
            serviceid: "mlf_metadataright"
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").
        then(function(data) {
            var obj = {};
            for (var i in data) {
                obj[data[i]] = true;
            }
            $scope.status.accessAuthority.command = obj;
        });
    }
}]);